import {Team} from '../../app/modules/team/models/Team.model'
import {intersection, isArray, map} from 'lodash'
import {TeamType} from '../../app/types/EmployeeType'

export const hasTeamMatch = (a: (Team | TeamType)[], b: (Team | TeamType)[]) =>{
	if(!isArray(a) || !isArray(b) ){
		throw("Not correct data");
	}
	return intersection(map(a, "id"), map(b, "id")).length > 0;
}